import React from 'react'

import KinerjaKSKonfirmasiProfilApp from 'app/KinerjaKSPage/pages/KonfirmasiProfil'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { SchoolProvider } from 'app/KinerjaKSPage/components/SchoolContentProvider'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardKSPNF } from 'app/KinerjaKepalaSKBPage/components/PageGuardKSPNF'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-spnf-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const KinerjaKSKonfirmasiProfil = () => {
  return (
    <PageGuardKSPNF>
      <SchoolProvider>
        <KinerjaKSKonfirmasiProfilApp skipEditConfirmation />
      </SchoolProvider>
    </PageGuardKSPNF>
  )
}

KinerjaKSKonfirmasiProfil.Layout = KinerjaLayout

KinerjaKSKonfirmasiProfil.layoutOpts = {
  hasHeader: true,
}

export default KinerjaKSKonfirmasiProfil
